import { Component } from "@angular/core";

@Component({
  selector: "app-icon-log-out",
  imports: [],
  templateUrl: "./icon-log-out.component.html",
  styleUrl: "./icon-log-out.component.scss",
})
export class IconLogOutComponent {}
